import type { ExperienceMode } from './resolveExperienceMode';

/**
 * Central policy for floating-dock behaviour by webdesigned shell (**mobile | pad | desktop**).
 *
 * Header is brand + site nav. Dock holds calendar, cart, VUM, account (login).
 * Quick book stays on product cards only — never in the dock.
 */

/** VUM control in the dock. */
export function dockShowsVumShell(_mode: ExperienceMode): boolean {
  return true;
}

/** Language picker in the dock (FR / EN / ZH abbreviations). */
export function dockShowsLanguageShell(_mode: ExperienceMode): boolean {
  return true;
}

/** Quick-book CTA — never in dock (product cards only). */
export function dockShowsBookShell(_mode: ExperienceMode): boolean {
  return false;
}

/** Scroll up / down — desktop only (mobile/pad use natural scroll). */
export function dockShowsScrollShell(mode: ExperienceMode): boolean {
  return mode === 'desktop';
}

/** @deprecated use dockShowsVumShell / dockShowsLanguageShell */
export function dockShowsVumAndLanguageShell(mode: ExperienceMode): boolean {
  return dockShowsVumShell(mode) && dockShowsLanguageShell(mode);
}

/** Safe-area dock bottom inset on touch shells; desktop uses standard margin only. */
export function dockUsesCompactBottomInset(mode: ExperienceMode): boolean {
  switch (mode) {
    case 'mobile':
    case 'pad':
      return true;
    case 'desktop':
      return false;
  }
}
